<template>
    <div class="buton-on-the-right" v-if="!displayShowDetails" style="max-width: 500px;">
        <span class="label">Active Shows:</span>
        <span style="text-align:right;">
            <v-btn size="x-small" color="primary" id="btn-refresh" @click="$emit('refresh-shows')">Refresh</v-btn>
            &nbsp;
            <v-btn size="x-small" color="primary" id="btn-add-show" @click="addNewShow">Add Show</v-btn>
        </span>
    </div>

    <transition-group name="slide-left" tag="div" v-if="!displayShowDetails">
        <div :key="show.id" v-for="show in shows" class="shows-list-item-container">
            <ShowTile :show="show" @view-show-details="onViewShowDetails" />
        </div>
    </transition-group>
    <div v-if="displayShowDetails">
        <ShowDetails :showToView="selectedShow" :idToken="idToken" :startInEditMode="startInEditMode"
            @close-details="displayShowDetails = false" @show-modified="onShowModified" />
    </div>
</template>

<script>
import ShowTile from './ShowTile.vue';
import ShowDetails from './ShowDetails.vue';
import { pProvShow } from '../../../photo-prov-shared/lib/classes/pprovShow.mjs';

export default {
    name: 'ShowsList',
    components: {
        ShowTile,
        ShowDetails
    },
    props: {
        shows: Array,
        idToken: String
    },
    emits: [
        'refresh-shows',
        'show-modified'
    ],
    mounted() {
    },
    data() {
        return {
            displayShowDetails: false,
            startInEditMode: false,
            selectedShow: null
        };
    },
    methods: {
        addNewShow() {
            this.selectedShow = new pProvShow({});
            this.displayShowDetails = true;
            this.startInEditMode = true;
        },
        onViewShowDetails(show) {
            this.selectedShow = show;
            this.displayShowDetails = true;
            this.startInEditMode = false;
        },
        onShowModified() {
            // we're simply passing this up the chain from ShowDetails to App.vue
            this.$emit('show-modified');
        }
    }
}
</script>

<style scoped>
.shows-list-item-container {
    border: 0px solid black;
    max-width: 450px;
}

/* Transition styles for sliding in from the left */
.slide-left-enter-active,
.slide-left-leave-active {
    transition: all 0.5s ease;
}

.slide-left-enter-from,
.slide-left-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}
</style>
